import * as React from 'react';
import styled from '@emotion/styled';
import { StaticQuery, graphql } from 'gatsby';
import Link from './link';

const Wrapper = styled('div')`
  width: 100%;
  height: 48px;
  background: rgba(255, 255, 255, 0.5);
  border-bottom: 1px solid rgba(15, 34, 67, 0.11);
  overflow: hidden;
`;

const TabsWidth = styled('div')`
  margin: 0 auto;
  width: 519px;
  display: flex;
  justify-content: space-between;
  a {
    display: block;
    position: relative;
    height: 48px;
    line-height: 48px;
    font-weight: 500;
    font-size: 16px;
    text-decoration: none;
    color: rgba(21, 22, 24, 0.72);
    &:hover,
    &.active {
      color: #3e6cff;
    }
    &.active::after {
      content: '';
      display: block;
      position: absolute;
      bottom: -2px;
      left: 50%;
      width: 20px;
      height: 6px;
      background: #3e6cff;
      border-radius: 3px;
      transform: translateX(-50%);
    }
  }
`;

const TopbarLayout = ({ location }) => (
  <StaticQuery
    query={graphql`
      query {
        allMdx {
          edges {
            node {
              fields {
                title
                slug
                order
              }
            }
          }
        }
      }
    `}
    render={({ allMdx }) => {
      const url = {},
        links = [];
      allMdx.edges.sort((a, b) => a.node.fields.order - b.node.fields.order);
      allMdx.edges.map((item) => {
        const paths = item.node.fields.slug.split('/');
        if (paths.length > 2) {
          if (!url[paths[1]]) {
            url[paths[1]] = item.node.fields.slug;
          }
        } else if (paths.length === 2 && paths[1] !== '') {
          links.push({
            name: item.node.fields.title,
            slug: paths[1],
          });
        }
      });
      return (
        <Wrapper>
          <TabsWidth>
            {links.map((item, index) => {
              return (
                <Link
                  key={index}
                  to={url[item.slug]}
                  className={location.pathname.indexOf(item.slug) === 1 ? 'active' : `${item.slug}`}
                >
                  {item.name}
                </Link>
              );
            })}
          </TabsWidth>
        </Wrapper>
      );
    }}
  />
);

export default TopbarLayout;
